module.exports = __webpack_public_path__ + "img/Logo_White_BG_transparent.45e6c54e.svg";